// MainLayout Component - Page wrapper with header, sidebar, and footer

import { useState, useCallback } from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { AdminSidebar } from './AdminSidebar';
import { Footer } from './Footer';
import { RedFlagBanner } from './RedFlagBanner';
import { GuruFeedbackWidget } from './GuruFeedbackWidget';
import { MetabaseModal } from './MetabaseModal';
import { AppErrorBoundary } from '../common/AppErrorBoundary';
import { RouteErrorBoundary } from '../common/RouteErrorBoundary';
import styles from './MainLayout.module.css';

export function MainLayout() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [showMetabaseModal, setShowMetabaseModal] = useState(false);

  const toggleSidebar = useCallback(() => {
    setSidebarCollapsed((prev) => !prev);
  }, []);

  const handleMetabaseClick = useCallback(() => {
    setShowMetabaseModal(true);
  }, []);

  return (
    <div className={styles.layout}>
      <Header
        onToggleSidebar={toggleSidebar}
        sidebarCollapsed={sidebarCollapsed}
      />
      <AppErrorBoundary scope="section" label="RedFlag banner">
        <RedFlagBanner />
      </AppErrorBoundary>
      <div className={styles.body}>
        <AdminSidebar
          collapsed={sidebarCollapsed}
          onMetabaseClick={handleMetabaseClick}
        />
        <main className={`${styles.main} ${sidebarCollapsed ? styles.mainExpanded : ''}`}>
          {/* Contain a crashing admin page to the content area so the header
              and sidebar keep working (kanban 90f3b9d8). */}
          <RouteErrorBoundary homeHref="/dashboard">
            <Outlet />
          </RouteErrorBoundary>
        </main>
      </div>
      <Footer />
      <GuruFeedbackWidget />
      <MetabaseModal
        isOpen={showMetabaseModal}
        onClose={() => setShowMetabaseModal(false)}
      />
    </div>
  );
}
